import React from 'react';
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001738625587.jpg';
import '../../styles/about.css';

const TaniTedavi13 = () => {
    return (
        <div>
            <h5 className='main-title'>PRP NEDİR, NİÇİN UYGULANIR?</h5>
            <hr />
            <p>PRP, Trombositten zengin plazma (kan) demektir. PRP tedavisinde kişinin kendi kanından elde edilen, pıhtı hücreleri ve büyüme faktörlerinden zengin plazma ile cildi yenilemekte kullanılan bir yöntemdir. Cilt yaralandığında, cildi tamir etmek için pıhtı hücreleri gerekir. Pıhtı hücreleri, büyüme faktörleri olarak adlandırılan maddeleri salgılayarak cildin tamir edilme sürecini başlatır. Ayrıca, yaralı bölgeye kök hücrelerini çekerler. Bu yüzden, cilde pıhtı hücrelerinden zengin PRP tedavisi yapıldığında ciltte onarılma ve yenilenme süreci tetiklenmiş olur.</p>

            <p>PRP, bu onarıcı ve yenileyici etkisi nedeniyle ortopedik ve cerrahi girişimlerde etkin bir şekilde kullanılmaktadır.</p>

            <p>Estetik dermatolojide ise; </p>

            <ul>
                <li>Cilt sarkmalarında,</li>
                <li>Kırışıklık tedavisinde,</li>
                <li>Leke ve sivilce tedavisinde,</li>
                <li>Yara izlerinin giderilmesinde,</li>
                <li>Cilt çatlaklarının düzeltilmesinde ve saç dökülmelerinde kullanılmaktadır.</li>
            </ul>

            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />

            <p>Uygulama için hastanın kanı, steril bir ortamda özel tüplere alınır. Özel tüpler, santrifüj denen alette belirli bir hızda ve sürede döndürülür. Özel tüpler olmadan elde edilen plazmada 200 bin civarında trombosit (pıhtı hücresi) vardır. Bu sayı, cildi yenilemekte yeterli olmaz. PRP tedavisinde kanın konulduğu özel tüpler sayesinde bir milyon pıhtı hücresi içeren plazma elde edilir. Bu sayı, cildi yenilemek için etkin ve yeterlidir. Elde edilen bu içerik, ciltte sorunlu bölgelere minik iğneler yardımıyla cilt altına ve içine verilir.</p>

            <p>İşlem yaklaşık yarım saatte tamamlanır. İlk günden itibaren ciltte parlaklık ve gerginlik görülmesine karşı, etki birkaç haftada görülür. Ciltteki sorunun çözülmesi için tek uygulama yeterli değildir. 2-4 hafta arayla en az 3 veya 4 uygulama yapılmalıdır. Yılda 1 veya 2 kez de tekrarı önerilir.</p>

            <p>Enjekte edilen içerik hastanın kendi kanıyla hazırlandığı için ve steril ortamda hazırlandığı için yan etki riski yoktur. İşlem sırasında oluşabilecek kızarıklık ve ödem, birkaç saat içinde geçer.</p>

            <p>Bazen yapılan iğnelere bağlı küçük ve geçici morluklar olabilir, ancak bunlar kısa sürede geçer.</p>

            <p>PRP tedavisi yapıldıktan sonra ciltte yenilenmeye bağlı; sıkılaşma, sarkmada azalma, kırışıklıklarda azalma, ciltteki lekelerde azalma ve cilt renginde aydınlanma görülür. Saçlı deriye uygulandığında saç kalınlığında artış ve seyrek alanlarda yoğunlaşma görülür.</p>

            <p>PRP, lazer ve peeling uygulamalarından hemen sonra derinin hızla yapılanmasını sağlamak için de kullanılabilir.</p>

            <p>PRP etkin ve güvenli bir uygulama olmakla birlikte, uzman kişiler tarafından uygun ortam ve koşullarda uygun kişilere yapılmalıdır.</p>
        </div>
    );
};

export default TaniTedavi13;
